import React from "react";
import ViewProductQuotation from "pages/QuotationV2/View/Product/ViewProductQuotation";
import ViewServiceQuotation from "pages/QuotationV2/View/Service/ViewServiceQuotation";

interface QuotationViewComponentProps {
  id: string;
  type: "product" | "service";
}

export const QuotationViewComponent: React.FC<QuotationViewComponentProps> = ({
  id,
  type,
}) => {
  return type === "product" ? (
    <ViewProductQuotation id={id} />
  ) : (
    <ViewServiceQuotation id={id} />
  );
};
